import { useState } from "react";
import { setTopAchiever } from "../actions/studensts";

// Only these roles may flag a student as a Top Achiever inline, since checking
// it writes a fee onto the student's invoice record.
const ALLOWED_ROLES = ["admin", "invoice"];

const LABEL = "Top Achiever";
const FEE = "500.00";

export default function TopAchieverField({ studentId, initialValue, initialFee }) {
  const role = JSON.parse(localStorage.getItem("profile"))?.value?.[0]?.role;
  const canEdit = ALLOWED_ROLES.includes(role);

  const [checked, setChecked] = useState(Number(initialValue) === 1);
  const [fee, setFee] = useState(
    initialFee === null || initialFee === undefined ? "" : String(initialFee)
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleToggle = async (e) => {
    const next = e.target.checked;
    if (saving) return;
    setSaving(true);
    setError("");
    const res = await setTopAchiever(studentId, next ? "1" : "0");
    setSaving(false);
    if (res && res.status === 200) {
      setChecked(next);
      setFee(res.data?.top_achievers_fee ?? (next ? FEE : "0.00"));
    } else {
      setError(res?.data?.ERROR || "Failed to save.");
    }
  };

  return (
    <div className="flex items-center flex-wrap gap-2">
      <label className="font-light" htmlFor={`top_achievers_${studentId}`}>
        {LABEL}:&nbsp;
      </label>

      {canEdit ? (
        <input
          id={`top_achievers_${studentId}`}
          type="checkbox"
          checked={checked}
          disabled={saving}
          onChange={handleToggle}
          className="w-4 h-4 accent-yellow-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
        />
      ) : (
        <span
          className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
            checked ? "bg-yellow-200 text-yellow-900" : "bg-gray-100 text-gray-500"
          }`}
        >
          {checked ? "Yes" : "No"}
        </span>
      )}

      {checked && (
        <span className="text-xs font-semibold text-yellow-800">
          Amount: {Number(fee || FEE).toFixed(2)}
        </span>
      )}

      {saving && <span className="text-xs text-gray-400">Saving...</span>}
      {error && <span className="text-xs text-red-500 w-full">{error}</span>}
    </div>
  );
}
